exports.components = {
  "component---src-templates-about-js": () => import("./../../../src/templates/about.js" /* webpackChunkName: "component---src-templates-about-js" */),
  "component---src-templates-newsletter-query-js": () => import("./../../../src/templates/newsletter-query.js" /* webpackChunkName: "component---src-templates-newsletter-query-js" */),
  "component---src-templates-post-query-js": () => import("./../../../src/templates/post-query.js" /* webpackChunkName: "component---src-templates-post-query-js" */),
  "component---src-templates-posts-query-js": () => import("./../../../src/templates/posts-query.js" /* webpackChunkName: "component---src-templates-posts-query-js" */)
}

